"use client";

import * as React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const propertiesData = [{
  property: "Material type",
  value: "Thermoset phenolic laminate"
}, {
  property: "Standard thicknesses",
  value: "{{verify: thickness list}}"
}, {
  property: "Dielectric strength",
  value: "{{verify: value + units}}"
}, {
  property: "Operating temperature range",
  value: "{{verify: range}}"
}, {
  property: "Flammability rating",
  value: "{{verify: UL 94 or rating}}"
}, {
  property: "Water absorption",
  value: "{{verify: value}}"
}, {
  property: "Density/specific gravity",
  value: "{{verify: value}}"
}, {
  property: "Surface finish",
  value: "{{verify: finish}}"
}];
export default function PhenolicProperties() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}